import routePath from '@src/lib/routePath'

const legacyBase = `/retailer/reporting/:retailerAccountSlug/:brandSlug`
const base = `/retailer/reporting/:retailerAccountSlug/all`
const reportingPaths = {
  index: routePath(`${base}/:campaignType?` as const),
  campaignTypeTab: routePath(`${base}/:campaignType` as const),
  organicCampaignDetails: routePath(
    `${base}/organic/:campaignId/:channel?` as const,
  ),
  paidCampaignDetails: routePath(`${base}/paid/:campaignId` as const),
}
export const legacyReportingPaths = {
  index: routePath(`${legacyBase}/:campaignType?` as const),
  campaignTypeTab: routePath(`${legacyBase}/:campaignType` as const),
  organicCampaignDetails: routePath(
    `${legacyBase}/organic/:campaignId/:channel?` as const,
  ),
  paidCampaignDetails: routePath(`${legacyBase}/paid/:campaignId` as const),
}

export default reportingPaths
